import { useAuthStore } from "@/store/auth";
import HandleError from "@/utils/handle-errors.util";
import { getTokenFromStorage } from "@/utils/user-store.util";
import axios, {
  AxiosError,
  type AxiosInstance,
  type AxiosRequestConfig,
  type AxiosResponse,
  type InternalAxiosRequestConfig,
} from "axios";

class UseAxios {
  private static apiConfig(baseUrl: string): AxiosRequestConfig {
    return { baseURL: baseUrl };
  }

  private static initAxios(config: AxiosRequestConfig): AxiosInstance {
    const instance = axios.create(config);

    instance.interceptors.request.use(
      (request: InternalAxiosRequestConfig) => {
        if (!useAuthStore.getData?.accessToken) return request;
        request.headers.set("Authorization", getTokenFromStorage());
        return request;
      },
      (error) => Promise.reject(error)
    );

    instance.interceptors.response.use(
      (response: AxiosResponse) => response,
      async (error: AxiosError) =>
        await new HandleError().getErrors(error, instance)
    );

    return instance;
  }

  static api(baseURL: string = "/api"): AxiosInstance {
    return UseAxios.initAxios(UseAxios.apiConfig(baseURL));
  }
}

export const api = UseAxios.api;
